import script from "./TableDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./TableDetail.vue?vue&type=script&setup=true&lang=js"

import "./TableDetail.vue?vue&type=style&index=0&id=1a58ce8c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a58ce8c"]])

export default __exports__